import { Box, Flex } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import {
  useTemplateMetaDataSelector,
  updateMetaData,
} from 'screens/admin/Objectives/GoalPreferences/slice/accessControlSlice';

import { DisplayName as DisplayNameIcon } from 'assets/assetsV1/iconComponents/DisplayName';

import { isNetchexLogin } from 'constants/netChexConstants';

import { Divider } from 'uiToolkitV1/Divider';
import { TextBodyLarge, TextLabel } from 'uiToolkitV1/Typography';

import { StyledInput } from '../../styles';
import ModuleItem from './ModuleItem';

const DisplayName = ({ isEditMode }) => {
  const { moduleName, objectivesName, keyResultsName } = useTemplateMetaDataSelector();
  const dispatch = useDispatch();

  const onChange = (key, value) => {
    dispatch(updateMetaData({ key, value }));
  };

  return (
    <Box padding="1rem">
      <Flex mb="1rem" justifyContent="space-between" alignItems="center">
        <DisplayNameIcon boxSize="24px" color="#666666" />
        <Box style={{ flexGrow: 1 }} ml="8px">
          <TextBodyLarge style={{ fontWeight: '600' }}>Display name</TextBodyLarge>
          <TextLabel color="text.g2">
            {isNetchexLogin
              ? "Customize how 'Objectives' and 'Key Results' are referred to across the platform"
              : "Customize how 'Goals' are referred to across the platform (navigation, headings, and home page)."}
          </TextLabel>
        </Box>
      </Flex>

      <Divider />

      {!isNetchexLogin && (
        <ModuleItem
          title="Custom name for 'Module'"
          description="Choose a name to customize Goals module name in navigation, headings and home page."
          component={
            <StyledInput
              isDashed
              disabled={!isEditMode}
              onChange={(e) => {
                onChange('moduleName', e.target.value);
              }}
              width="10rem"
              value={moduleName}
            />
          }
        />
      )}

      <ModuleItem
        title="Custom name for 'Objectives'"
        description="Choose a singular version to customize name in buttons, panels and messages. E.g. Add Objective, Clone Objective, etc."
        component={
          <StyledInput
            disabled={!isEditMode}
            onChange={(e) => {
              onChange('objectivesName', e.target.value);
            }}
            width="10rem"
            isDashed
            value={objectivesName}
          />
        }
      />
      <ModuleItem
        title="Custom name for 'Key Results'"
        description="Choose a singular version to customize name in buttons, panels and messages. E.g. Add Key Result, Share Key Result, etc."
        component={
          <StyledInput
            disabled={!isEditMode}
            onChange={(e) => {
              onChange('keyResultsName', e.target.value);
            }}
            width="10rem"
            isDashed
            value={keyResultsName}
          />
        }
      />
    </Box>
  );
};

export default DisplayName;
